import {Link} from "react-router-dom";

const NewsCard = ({ data, url }) => {
  return (
    <Link to={url} className="news_card">
      <img
        src={data?.img}
        alt=""
      />
      <div className="news_card_content">
        <h2>{data?.title}</h2>
        <p>{data?.desc}</p>
      </div>
    </Link>
  );
};

export default NewsCard;
